import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  MdDelete,
  MdModeEditOutline,
  MdPriceChange,
  MdSubtitles,
} from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import {
  deleteStockReconcillation,
  getStockReconcillation,
} from '../../network/stockReconcillation';
import { deleteStockEntry, getStockEntry } from '../../network/stockEntry';
import {
  deleteLandedCostVoucher,
  getLandedCostVoucher,
} from '../../network/landedCostVoucher';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import { TiCancel } from 'react-icons/ti';
import {
  deleteEmployeeAdvance,
  getEmployeeAdvance,
} from '../../network/employeeAdvance';
import { FaMoneyBillWave } from 'react-icons/fa';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';
const EmployeeAdvance = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteEmployeeAdvance(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getEmployeeAdvance] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Employee Advance', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getEmployeeAdvance] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Employee Advance', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getEmployeeAdvance] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getEmployeeAdvance],
    queryFn: () => getEmployeeAdvance(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: <MdModeEditOutline />,
      onClick: () => {
        navigate(`/employee-advance/edit/${record?.name}`);
      },
    },
    {
      key: '3',
      label: t.Payment,
      icon: <MdPriceChange />,
      onClick: () => {
        navigate(`/employee-advance/payment/${record?.name}`);
      },
      disabled: record?.status === 'Unpaid' ? false : true,
    },
    {
      key: '4',
      label: t.salaryDeduction,
      icon: <MdSubtitles />,
      onClick: () => {
        navigate(`/employee-advance/salary-deduction/${record?.name}`);
      },
      disabled: record?.status === 'Paid' ? false : true,
    },
    {
      key: '2',
      label: t.submit,
      icon: <FaMoneyBillWave />,
      onClick: () => {
        handleSubmit.mutate(record?.name);
      },
      disabled: record?.status === 'Draft' ? false : true,
    },

    {
      key: '3',
      label: t.cancel,
      icon: <TiCancel />,
      onClick: () => {
        handleCancle.mutate(record?.name);
      },
      disabled: record?.status === 'Submitted' ? false : true,
    },

    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.deleteEmployeeAdvance + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.employeeName,
      dataIndex: 'employee_name',
      key: 'employee_name',
    },
    {
      title: t.advanceAmount,
      dataIndex: 'advance_amount',
      key: 'advance_amount',
    },
    {
      title: t.status,
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => <StatusTag status={record?.status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/employee-advance/edit/${record?.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            {record?.status === 'Draft' && (
              <Popover
                placement="top"
                title={t.submit}
                onClick={() => {
                  handleSubmit.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#28a745' }}
                  icon={<MdSubtitles />}
                />
              </Popover>
            )}
            {record?.status === 'Unpaid' && (
              <Popover
                placement="top"
                title={t.Payment}
                onClick={() => {
                  navigate(`/employee-advance/payment/${record?.name}`);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#2874a7' }}
                  icon={<FaMoneyBillWave />}
                />
              </Popover>
            )}
            {record?.status === 'Paid' && (
              <Popover
                placement="top"
                title={t.salaryDeduction}
                onClick={() => {
                  navigate(
                    `/employee-advance/salary-deduction/${record?.name}`
                  );
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#2898a7' }}
                  icon={<MdPriceChange />}
                />
              </Popover>
            )}

            {record?.status === 'Submitted' && (
              <Popover
                placement="top"
                title={t.Cancel}
                onClick={() => {
                  handleCancle.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#ff4d4f' }}
                  icon={<TiCancel />}
                />
              </Popover>
            )}
            <Popconfirm
              title={t.deleteEmployeeAdvance + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.HR} subTitle={t.EmployeeAdvance} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/employee-advance/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddEmployeeAdvance}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default EmployeeAdvance;
